module.exports = __webpack_public_path__ + "static/media/music_btn.194e5a45.png";